import { useState } from 'react';

import getCookie from '../../Queries/getCookie';

import XVEstrellas from '../../../images/consultancy/imagen-15-estrellas-horizontal.jpg';
import XVEstrellasMobile from '../../../images/consultancy/imagen-15-estrellas-mobile.jpg';

//Components
import Button from '@mui/material/Button';
import Condiciones from '../Condiciones';

// styles
import styles from './index.module.sass';

export default function FelicitacionesXVEstrellas({
  idCuestionario,
  setIsOpenModal,
  setSessionMessage,
  screenSize,
}) {
  const [mostrarNuevoComponente, setMostrarNuevoComponente] = useState(false);

  function continuar() {
    setMostrarNuevoComponente(true);
  }

  return (
    <div>
      {mostrarNuevoComponente ? (
        <Condiciones
          idCuestionario={idCuestionario}
          setSessionMessage={setSessionMessage}
          screenSize={screenSize}
          setIsOpenModal={setIsOpenModal}
        />
      ) : (
        <>
          <div className={styles.header}>✨ ¡Felicidades {getCookie('kitName')}✨</div>
          {/* <div className={styles.body}>
            Tu dedicación, esfuerzo y liderazgo excepcional han sido fundamentales para alcanzar
            este logro tan significativo. Este reconocimiento no solo refleja tu compromiso y
            pasión, sino también la inspiración que brindas a quienes te rodean y con las cuales
            conforman un gran equipo.
          </div>
          <div>
            🌟 Eres un ejemplo de excelencia y perseverancia, y este es solo el comienzo de mayores
            éxitos por venir. ¡Sigue brillando y marcando la diferencia! 🌟
          </div>
          <div className={styles.footer}>¡Enhorabuena por este gran logro!</div>
          <div className={styles.footer}>
            <Button className={styles.button} variant='contained' onClick={continuar}>
              Continuar
            </Button>
          </div> */}
          <div className={`${styles.containerImage} ${styles[screenSize]}`}>
            <img
              src={screenSize === 'phone' ? XVEstrellasMobile : XVEstrellas}
              alt='XVEstrellas'
              className={`${styles.imageXV} ${styles[screenSize]}`}
            />
          </div>

          <div className={styles.footer}>
            <Button className={styles.button} variant='contained' onClick={continuar}>
              Continuar
            </Button>
          </div>
        </>
      )}
    </div>
  );
}
